import { ApiReducer, HTTP_STATUS, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiDeactivateGuestPaymentRegistration } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { PaymentMethodRegistration } from './paymentRegistration';
import { updateGuest } from '../module';
import * as R from 'ramda';
import { GuestDetails } from '../guestDetails';


const KEY_ACTION = ACTION_TYPE.DEACTIVATE_GUEST_PAYMENT_REGISTRATION_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.DEACTIVATE_GUEST_PAYMENT_REGISTRATION_REQUEST,
  ACTION_TYPE.DEACTIVATE_GUEST_PAYMENT_REGISTRATION_RESPONSE,
  ACTION_TYPE.DEACTIVATE_GUEST_PAYMENT_REGISTRATION_ERROR,
];


/**
 * Constructs a Redux Action for getting deactivating a specific guest payment registration
 * @param paymentRegistration - The guest payment registration to be deactivated
 */
export const deactivateGuestPaymentRegistrationAction = (registration: PaymentMethodRegistration) => makeApiAction(
  {
    method:   'PUT',
    endpoint: apiDeactivateGuestPaymentRegistration(registration.registrationId),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { registration } })) as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, registration.registrationId.toString(), KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<PaymentMethodRegistration> = (state, action, error, isLoading) => {
  const registration = action.meta.registration;
  const guestId = registration.masterGuestId;

  if (isLoading) {
    return addLoading(state, registration.registrationId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  // Not found is expected if the registration is not found in the DB
  if (error && action.payload.status !== HTTP_STATUS.NOT_FOUND) {
    return addError(withBreaker, registration.registrationId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, registration.registrationId, KEY_ACTION);

  // Update guest - remove registration from the guest in state
 return updateGuest(
     state,
     guestId,
     (guest: GuestDetails) => {
       const updatedRegistrations =  (guest.paymentRegistrations || []).filter(r => r.registrationId !== registration.registrationId);
       return R.assocPath([ 'paymentRegistrations' ], updatedRegistrations, guest);
     },
   );
};


export const deactivateGuestPaymentRegistrationReducer = makeApiReducer<PaymentMethodRegistration>(ACTIONS, KEY_ACTION, reducer);
